<template>
    <div>
        <div class="title" :style="getTitleStyle()">
            {{ myObj.photo_classify_plat_params.title }}
        </div>
        <div class="list-box" :style="getListBoxStyle()">
            <div v-for="(item, index) in myObj.component_source.params.total" :key="index" :style="getItemStyle()"
                :class="['item', getItemNameClass()]">
                <span v-if="myObj.photo_classify_plat_params.text_show">
                    名称
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PhotoClassifyPlatView",
    props: ['obj'],
    data() {
        return {
            myObj: this.obj
        }
    },
    methods: {
        getTitleStyle() {
            return 'margin-left: ' + this.obj.photo_classify_plat_params.margin + 'px;';
        },
        getListBoxStyle() {
            return 'padding-left: ' + this.obj.photo_classify_plat_params.margin + 'px;' +
                'gap:' + this.obj.photo_classify_plat_params.between_space + 'px;' +
                'padding-bottom: ' + this.obj.photo_classify_plat_params.margin + 'px;';
        },
        getItemStyle() {
            const width = Math.floor((375 - this.obj.photo_classify_plat_params.margin * 2
                - (this.obj.photo_classify_plat_params.column - 1) * this.obj.photo_classify_plat_params.between_space)
                / this.obj.photo_classify_plat_params.column);
            const height = width * this.obj.photo_classify_plat_params.item_height_ratio / 100;
            return 'width:' + width + "px;" +
                'height:' + height + "px;" +
                'border-radius:' + this.obj.photo_classify_plat_params.corner_radius + "px;";
        },
        getItemNameClass() {
            if (this.obj.photo_classify_plat_params.text_position) {
                return 'name' + this.obj.photo_classify_plat_params.text_position;
            }
            return 'name5';
        }
    }
}
</script>

<style scoped lang="less">
.title {
    color: black;
    font-size: medium;
    line-height: 40px;
}

.list-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
}

.item {
    position: relative;
    background-color: #D8D8D8;
    padding: 5px;
    box-sizing: border-box;
}

.name1 {
    text-align: left;
}

.name2 {
    text-align: center;
}

.name3 {
    text-align: right;
}

.name4 {
    display: flex;
    align-items: center;
}

.name5 {
    display: flex;
    align-items: center;
    justify-content: center;
}

.name6 {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
}

.name7 {
    display: flex;
    align-items: flex-end;
}

.name8 {
    display: flex;
    align-items: center;
    flex-direction: column-reverse;
}

.name9 {
    display: flex;
    align-items: flex-end;
    flex-direction: row-reverse;
}
</style>